<div class="main-container mat-typography mat-body">

  <!-- Main Container -->
  <mat-card appearance="outlined" class="find-medication-card">

    <mat-card-header>
      <mat-card-title>
        <h2 class='med-title'>{{componentHeader}} <small>{{componentSubTitle}}</small></h2>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <!-- Sub-Title -->
      <div class="description-container">
        {{ componentDescription }}
        <br/>
        <em>Fields marked with an asterisk (<span style="color: #a71919;">*</span>) are required.</em>
      </div>

      <!-- Search -->
      <div class="medication-container">
        <form [formGroup]="autocompleteForm">
          <mat-form-field class="autocomplete-field" floatLabel="">
            <mat-label>
              {{ autoCompleteSearchLabel }}
            </mat-label>
            <input
              type="text"
              matInput
              formControlName="userSearch"
              [matAutocomplete]="auto"
              #autoTrigger
              (focus)="triggerPanelOpen()"/>

              <!-- Not sure why, but matTextSuffix looks good and matSuffix looks like crap -->
              @if (isLoadingAutocomplete) {
                <mat-spinner matTextSuffix diameter="25"></mat-spinner>
              }

              <!-- Drug Lookup, results -->
              <mat-autocomplete
                class="medication-information-component-autocomplete"
                #auto="matAutocomplete"
                panelWidth="auto">
                @for (drug of autoCompleteLookupResults; track drug) {
                  <mat-option
                    [value]="drug.name"
                    (click)="isLoadingDrugResults = true; findAllDrugsFromName(drug)">
                    <div class="autocomplete-item">
                      <div class="autocomplete-drug-name">
                        <span>{{ drug.name }}</span>
                      </div>
                      <div class="autocomplete-add-button">
                        <span class="material-symbols-outlined">search</span>
                      </div>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            @if (!isLoadingAutocomplete) {
              @if (!hasEnoughSearchChars && autocompleteForm.controls['userSearch'].dirty) {
                <mat-error>
                  You must enter at least 3 characters
                </mat-error>
              }
              @if (hasEnoughSearchChars && hasNoAutocompleteResults) {
                <mat-error>
                  No results found
                </mat-error>
              }
            }
          </form>

          <div class='drug-container'>
            <div>
              <h3>Available Drugs</h3>
            </div>

            <div>
              <h3>Selected Drugs</h3>
            </div>

            <div class='pre-selecton-container'>
              @if (!isLoadingDrugResults) {
                @for (drug of drugsAvailalbleForSelection; track drug; let index = $index) {
                  <mat-card appearance="outlined" class="drug-info">
                    <mat-card-content>
                      <div class="information-title">
                        <div class='drug-content center-inside'>
                          <h4 class="drug-name">
                            {{ drug.name }}
                          </h4>
                          <p>
                            {{ drug.full_name }}
                          </p>
                        </div>
                        <!-- Remove Item -->
                        <div class="form-control-container autocomplete-remove-button">
                          <div class="center-inside">
                            <span
                              class="material-symbols-outlined"
                              tabindex="0"
                              role="button"
                              (click)="addDrugToSelected(drug, index)">add_circle
                            </span>
                          </div>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
              }

              @if (isLoadingDrugResults) {
                <mat-card appearance="outlined">
                  <mat-card-content>
                    @if (isLoadingAutocomplete) {
                      <mat-spinner matTextSuffix diameter="25"></mat-spinner>
                    }
                  </mat-card-content>
                </mat-card>
              }

              @if (!drugsAvailalbleForSelection.length && !isLoadingDrugResults && hasSearchedDrugs) {
                <mat-card appearance="outlined">
                  <mat-card-content>
                    <p>
                      <em>There are no results for the provided search and/or
                      you have selected all the drugs for this search</em>
                    </p>
                  </mat-card-content>
                </mat-card>
              }

              @if (!drugsAvailalbleForSelection.length && !isLoadingDrugResults && !hasSearchedDrugs) {
                <mat-card appearance="outlined">
                  <mat-card-content>
                    <p><em>Type and select a value from the list above to see available drug options</em></p>
                  </mat-card-content>
                </mat-card>
              }
            </div>

            <!-- Selected Drugs (start) -->
            <div class='selected-meds-container'>
              @for (drug of selectedMedications; track drug; let index = $index) {
                <mat-card appearance="outlined" class="drug-info">
                  <mat-card-content>
                    <div class="information-title">
                      <div class='drug-content center-inside'>
                        <h4 class="drug-name">
                          {{ drug.name }}
                        </h4>
                        <p>
                          {{ drug.full_name }}
                        </p>
                      </div>
                      <!-- Remove Item -->
                      <div class="form-control-container autocomplete-remove-button">
                        <div class="center-inside">
                          <span
                            class="material-symbols-outlined"
                            tabindex="0"
                            role="button"
                            (click)="removeDrugFromSelected(drug, index)">delete_forever
                          </span>
                        </div>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              }

              @if (!selectedMedications.length) {
                <mat-card appearance="outlined">
                  <mat-card-content>
                    <p>
                      <em>You have no drugs selected</em>
                    </p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </div>
        </div>
      </mat-card-content>
      <mat-card-footer>
        <div class="button-container">
          <a href="" (click)="$event.preventDefault();navBack()">
            <span class="material-symbols-outlined">arrow_back</span>
            <span>BACK</span>
          </a>
          <a href="" (click)="$event.preventDefault();submit(autocompleteForm)">
            <span>NEXT</span>
            <span class="material-symbols-outlined">arrow_forward</span>
          </a>
        </div>
      </mat-card-footer>
    </mat-card>
  </div>

